module.exports = __webpack_public_path__ + "assets/contract.e4e394bb.svg";